import { useState, useEffect, useRef } from 'react'
import { useRecords } from '@/contexts/record-context'

export function useTimer() {
  const { activeTimer } = useRecords()
  const [elapsed, setElapsed] = useState(0)
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

  useEffect(() => {
    if (activeTimer) {
      const update = () => {
        setElapsed(Math.floor((Date.now() - activeTimer.startTime) / 1000))
      }
      update()
      intervalRef.current = setInterval(update, 1000)
    } else {
      setElapsed(0)
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [activeTimer])

  const hours = Math.floor(elapsed / 3600)
  const minutes = Math.floor((elapsed % 3600) / 60)
  const seconds = elapsed % 60

  const display = hours > 0
    ? `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    : `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`

  return { elapsed, display, hours, minutes, seconds }
}
